import config from '../../../../program-section-types-config.json'
import { ErrorMessage } from 'formik'
import {FILTER, EXPIREDATE, CONTENT} from '../../../../constants/programSectionTypes'
import FieldWrapper from '../../FieldWrapper.jsx';
import AddNewSectionExpireDate from './AddNewSectionExpireDate.jsx';
import AddNewSectionContent from './AddNewSectionContent.jsx';
import AddNewSectionFilterContainer from '../../../../containers/forms/fields/AddNewSection/AddNewSectionFilterContainer.jsx';
import Translation from '../../../Translation/cont/Translation';

const AddNewSectionTypesOption = ({values, errors, touched, allGenres, technicalAttributes}) => {
    const {options, typeContent} = config
    const typeID = values.type 
    const activeType = typeContent[typeID]
    const activeOption =  activeType ? activeType.options : false
    const option = activeOption ? options[activeOption] : false
    const label = option ? option.transId ?  <Translation id={option.transId } /> : option.name : <Translation id="section_select_element_type" />

    const allOptions = () => {
        if(activeOption === FILTER) {
            return <AddNewSectionFilterContainer technicalAttributes={technicalAttributes} genres={allGenres} values={values} />

        } else if(activeOption === EXPIREDATE) {
            return <AddNewSectionExpireDate label={activeOption} />

        } else if(activeOption === CONTENT) {
            return <AddNewSectionContent values={values} />

        } else {
            return ''
        }
    }
    
    return ( 
        <FieldWrapper label={label} id="options" wrapperClasses="field-wrapper-children-wrapper" classes="options-wrapper">
            {allOptions()} 
        </FieldWrapper>
    )
}

export default AddNewSectionTypesOption